import { Pipe, PipeTransform } from "@angular/core";

//create a pipe to format the image url
@Pipe({
  name: "thumbnalize",
  standalone: true,
})
export class ThumbnalizePipe implements PipeTransform {
  transform(listing: any): any {
    var modifiers = "cmore-h75-w75";
    var image = listing.thumbnail_image || listing.main_image || listing.url;
    if (image) {
      return image
        .replace(
          "https://s3.amazonaws.com/elasticbeanstalk-us-east-1-462591887108/",
          "http://cdn.nowinstore.com/" + modifiers + "/"
        )
        .replace(
          "https://cdn.shopify.com/",
          "http://cdn.nowinstore.com/eshopify-" + modifiers + "/"
        )
        .replace(
          "undefined/cmore-h75-w75/",
          "http://cdn.nowinstore.com/" + modifiers + "/"
        ) //fix for erreneous thumbnails
        .replace(
          "undefined/cmore-h64-w64/",
          "http://cdn.nowinstore.com/" + modifiers + "/"
        ) //fix for erreneous thumbnails
        .replace(
          "https://cdn2.bigcommerce.com/",
          "http://cdn.nowinstore.com/ebigcommerce-" + modifiers + "/"
        );
    }
    return "https://s3.amazonaws.com/nowinstore.com/no-image.jpg";
  }
}
